import Vue from 'vue'

export default {
	state: {
		summary: {},
		monthsSales: [],
		franchisesStores: [],
		chainTrademarks: []
	},
	mutations: {
		loadSummary (state, payload) {
			state.summary = payload
		},
		loadMonthsSales (state, payload) {
			state.monthsSales = payload
		},
		loadFranchisesStores (state, payload) {
			state.franchisesStores = payload
		},
		loadChainTrademarks (state, payload) {
			state.chainTrademarks = payload
		},
		addSummary (state, payload) { 
			Vue.set(state.summary, payload.key, payload.val)  
		},
		addMonthSales (state, payload) {
			const index = state.monthsSales.length 
			Vue.set(state.monthsSales, index, payload)  
		},
		addFranchiseStore (state, payload) {
			const index = state.franchisesStores.length 
			Vue.set(state.franchisesStores, index, payload)  
		},
		addChainTrademarks (state, payload) {
			const index = state.chainTrademarks.length 
			Vue.set(state.chainTrademarks, index, payload)  
		}
	},
	actions: {
		async fetchSummary ({commit, getters}, payload=null) {
			commit('clearError')
			commit('setLoading', true)
			
			let gameId = 'game'
			let round = 'round'

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
			}
			else {
				gameId += getters.gameId
				round += getters.currentRound - 1
			}

			try {
				const summary = await Vue.$db.collection(gameId).doc(round)
				.collection('summary')
				.get()

				if (summary.empty) {//no summary
					console.log('no summary')	
				}
				else {
					const res = {}
					summary.forEach(doc => {
						const sum = doc.data()
						for (let key in sum) {
							res[key] = sum[key]
						}
					})
				
					commit('loadSummary', res)
				}
				
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchMonthsSales ({commit, getters}, payload=null) {
			commit('clearError')
			commit('setLoading', true)

			let gameId = 'game'
			let round = 'round'

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
			}
			else {
				gameId += getters.gameId
				round += getters.currentRound - 1
			}

			try {
				const sales = await Vue.$db.collection(gameId).doc(round)
				.collection('monthsSales')
				.orderBy("month", "asc")
				.get()

				if (sales.empty) {//no sales
					console.log('no month sales')	
				}
				else {
					const res = []
					sales.forEach(doc => {
						const month = doc.data()
						month.id = doc.id
						res.push(month)
					})
				
					commit('loadMonthsSales', res)
				}
				
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchFranchisesStores ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			try {
				const franchises = await Vue.$db.collection('game'+ payload.gameId).doc('round'+ payload.round)
				.collection('franchiseStores')
				.get()

				if (franchises.empty) {//no franchises
					console.log('no franchises')	
				}
				else {
					const res = []
					franchises.forEach(doc => {
						const store = doc.data()
						store.id = doc.id
						res.push(store)
					})
				
					commit('loadFranchisesStores', res)
				}
				
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchChainTrademarks ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			try {
				const docs = await Vue.$db.collection('game'+ payload.gameId).doc('round'+ payload.round)
				.collection('chainTrademarks')
				.get()

				if (docs.empty) {//no docs
					console.log('no chainTrademarks')	
				}
				else {
					const res = []
					docs.forEach(doc => {
						const item = doc.data()
						item.id = doc.id
						res.push(item)
					})
				
					commit('loadChainTrademarks', res)
				}
				
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addSummary ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			try {
				const summaryRef = await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
				.collection('summary')
				.get()

				if (summaryRef.empty) {
					await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
					.collection('summary')
					.add({[payload.key]: payload.val})
				}
				else {
					const id = summaryRef.docs[0].id
					const _ = await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
					.collection('summary').doc(id)
					.set({[payload.key]: payload.val}, {merge: true})
				}

				commit('setLoading', false)
				commit('addSummary', payload)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addMonthSales ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			
			const id = `salesMonth-${payload.monthSales.month}`
			try {
				await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
				.collection('monthsSales')
				.doc(id)
				.set(payload.monthSales)

				payload.monthSales.id = id

				commit('setLoading', false)
				commit('addMonthSales', payload.monthSales)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addFranchiseStore ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			
			try {
				const frRef = await Vue.$db.collection('game' + payload.gameId).doc('round' + payload.round)
				.collection('franchiseStores')
				.add(payload.franchise)

				payload.franchise.id = frRef.id

				commit('setLoading', false)
				commit('addFranchiseStore', payload.franchise)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		}, 
		async addChainTrademarks ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			//console.log(payload)
			try {
				const docRef = await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
				.collection('chainTrademarks')
				.add(payload.chainTrademark)

				payload.chainTrademark.id = docRef.id

				commit('setLoading', false)
				commit('addChainTrademarks', payload.chainTrademark)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		}   
	},
	getters: {
		summary (state) {
			return state.summary
		},
		actualPeakSize (state) {
			if (state.summary.actualPeakSize)
				return state.summary.actualPeakSize
			return null
		},
		trademarkAwareness (state) {
			if (state.summary.trademarkAwareness)
				return state.summary.trademarkAwareness
			return null
		},
		advancedFeatureAcceptance (state) {
			if (state.summary.advancedFeatureAcceptance)
				return state.summary.advancedFeatureAcceptance
			return null
		},
		brandLoyalty (state) {
			if (state.summary.brandLoyalty)
				return state.summary.brandLoyalty
			return null
		},
		channelsSales (state) {
			if (state.summary.channelsSales)
				return state.summary.channelsSales
			return null
		},
		franchisesStores (state) {
			return state.franchisesStores
		},
		chainTrademarks (state) {
			return state.chainTrademarks
		},
		monthsSales (state) {
			return state.monthsSales    
		}
	}
}